import "@tvg/fuse/styles.css";
import React from "react";
import { hydrateRoot } from "react-dom/client";
import Header from "./views/Header/Header";

const container = document.getElementById("headerRoot");

if (process.env.NODE_ENV !== "production") {
  // Mock ODM object for local development
  window.ODM = {
    s4l: {
      getList: async () =>
        new Promise((resolve) => {
          setTimeout(() => {
            resolve({ status: 200, data: { items: [1, 2] } }); // Mocked response
          }, 10); // Simulate async delay
        }),
    },
    basket: {
      getCount: async () =>
        new Promise((resolve) => {
          setTimeout(() => {
            resolve({ status: 200, data: 0 }); // Mocked response
          }, 10); // Simulate async delay
        }),
    },
  };

  // const productData = {
  //   savedProducts: [
  //     {
  //       productId: "1600554059",
  //     },
  //   ],
  // };

  // // Store in session storage
  // sessionStorage.setItem("sfl_product_list", JSON.stringify(productData));
}

if (container) {
  hydrateRoot(container, <Header {...__INITIAL_STATE_header__} />);
}
